import { API_URL } from '../config/constants';
import axios from 'axios';

export interface Book {
  id: number;
  title: string;
  author: string;
  description: string;
  coverImage?: string;
  category?: string;
  publishedYear?: number;
  language?: string;
  fileName?: string;
  fileType?: string;
  createdAt?: string;
  updatedAt?: string;
  isFavorite?: boolean;
}

// Funcție pentru a obține toate cărțile
export const getAllBooks = async () => {
  try {
    const response = await axios.get(`${API_URL}/books`);
    return response.data;
  } catch (error) {
    console.error('Eroare la obținerea cărților:', error);
    throw error;
  }
};

// Funcție pentru a obține cărțile adăugate recent
export const getRecentlyAddedBooks = async (limit = 6) => {
  try {
    const response = await axios.get(`${API_URL}/books/recent?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Eroare la obținerea cărților recente:', error);
    throw error;
  }
};

// Funcție pentru a obține o carte după ID
export const getBookById = async (id: number) => {
  try {
    const response = await axios.get(`${API_URL}/books/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Eroare la obținerea cărții cu ID ${id}:`, error);
    throw error;
  }
};

// Funcție pentru a căuta cărți
export const searchBooks = async (query: string) => {
  try {
    const response = await axios.get(`${API_URL}/books?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error('Eroare la căutarea cărților:', error);
    throw error;
  }
};

// Funcție pentru a adăuga o carte la favorite
export const addBookToFavorites = async (bookId: number, token: string) => {
  try {
    const response = await axios.post(
      `${API_URL}/users/favorites/${bookId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Eroare la adăugarea cărții la favorite:', error);
    throw error;
  }
};

// Funcție pentru a elimina o carte din favorite
export const removeBookFromFavorites = async (bookId: number, token: string) => {
  try {
    const response = await axios.delete(`${API_URL}/users/favorites/${bookId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Eroare la eliminarea cărții din favorite:', error);
    throw error;
  }
};

// Funcție pentru a descărca o carte
export const downloadBook = (bookId: number, token?: string) => {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  // Deschide într-o fereastră nouă pentru descărcare
  window.open(`${API_URL}/books/${bookId}/download`, '_blank');
};

export default {
  getAllBooks,
  getRecentlyAddedBooks,
  getBookById,
  searchBooks,
  addBookToFavorites,
  removeBookFromFavorites,
  downloadBook
}; 